const root = 'http://www.cqaedi1993.com'
const login = 'http://www.cqaedi1993.com/control/adIndex.php?cla=login'
export default {
  root,
  login,
  jugClientWidth () {
    const cWidth = document.documentElement.clientWidth
    let mode = ''
    if (cWidth > 768) {
      mode = 'pc'
    } else {
      mode = 'mobile'
    }
    return mode
  },
  // 是否橫屏
  isHorizontal () {
    const cWidth = document.documentElement.clientWidth
    const cHeight = document.documentElement.clientHeight
    // console.log('cWidth:' + cWidth)
    // console.log('cHeight:' + cHeight)
    let horizontal = true
    // 豎屏
    if (cWidth < cHeight) {
      horizontal = false
    }
    return horizontal
  },
  getScrollTop () {
    const scrollTop = document.documentElement.scrollTop || window.pageYOffset || document.body.scrollTop
    return scrollTop
  },
  sortAsc (property) {
    return function (a, b) {
      const val1 = a[property]
      const val2 = b[property]
      return val1 - val2
    }
  }
}
